/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bot_Store_3Inputs */

const en_bot_store_3 = /** @type {(inputs: Bot_Store_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Screenshots and the page text that was read are deleted automatically after 7 days.`)
};

const id_bot_store_3 = /** @type {(inputs: Bot_Store_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tangkapan layar dan teks halaman yang dibaca dihapus otomatis setelah 7 hari.`)
};

/**
* | output |
* | --- |
* | "Screenshots and the page text that was read are deleted automatically after 7 days." |
*
* @param {Bot_Store_3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const bot_store_3 = /** @type {((inputs?: Bot_Store_3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bot_Store_3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_bot_store_3(inputs)
	return en_bot_store_3(inputs)
});